<template>
  <v-app-bar
    absolute
    flat
    class="pl-5 pr-5 dflex"
    app
    :color="$vuetify.theme.dark ? 'surface_tertiary' : 'surface_primary'"
    height="104px"
  >
    <v-toolbar-title class="toolbarAppBar">
      <router-link class="d-flex align-center" to="/" aria-label="SocialCam — página inicial">
        <LittleGreenLogo v-if="$vuetify.theme.isDark" class="app-logo" />
        <GreenLogo v-else class="app-logo" />
      </router-link>
    </v-toolbar-title>
    <TabSwitch v-if="!adminRoutes.includes($route.name)" class="ml-8" />
    <v-spacer />
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <button
          class="appbar-pill-btn appbar-pill-request"
          aria-label="Solicitar alteração"
          v-bind="attrs"
          v-on="on"
          @click="showComingSoon('Solicitar alteração')"
        >
          <v-icon size="18">mdi-clipboard-text-outline</v-icon>
        </button>
      </template>
      <span>Solicitar Alteração</span>
    </v-tooltip>
    <div class="appbar-separator" />
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <button
          class="appbar-pill-btn appbar-pill-bug"
          aria-label="Reportar bug"
          v-bind="attrs"
          v-on="on"
          @click="showComingSoon('Reportar bug')"
        >
          <v-icon size="18">mdi-bug-outline</v-icon>
        </button>
      </template>
      <span>Reportar Bug</span>
    </v-tooltip>
    <AppProfile class="ml-3" />
  </v-app-bar>
</template>

<script>
import AppProfile from "./AppProfile.vue";
import { mapActions } from "vuex";
import TabSwitch from "./TabSwitch.vue";
import LittleGreenLogo from "@/assets/little_green_logo_socialcam.svg";
import GreenLogo from "@/assets/green_logo_socialcam.svg";

export default {
  name: "AppBar",
  components: { AppProfile, TabSwitch, LittleGreenLogo, GreenLogo },
  data() {
    return {
      adminRoutes: ["producoes", "usuarios", "aprovadores", "log", "cameras", "enquetes-categorias"],
    };
  },
  mounted() {
    const stored = JSON.parse(localStorage.getItem("@socialcam/modoAtualizacaoColabs"));
    if (stored !== null && stored !== undefined) {
      this.setColabsUpdateMode(stored);
    }
  },
  methods: {
    ...mapActions({
      setColabsUpdateMode: "producoes/setColabsUpdateMode",
    }),
    showComingSoon(label) {
      this.$toast.info(`${label} — em breve!`);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-logo {
  width: 200px;
  height: 36px;
}

.v-tab {
  color: var(--v-secondary-base) !important;
  text-transform: none !important;
}

.medium-spacing {
  gap: 4rem;
}

.v-switch {
  height: 1.25rem;
}
.v-theme-select {
  padding: 0;

  label {
    font-size: 0.875rem;
  }
}

.appbar-pill-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 34px;
  background: transparent;
  border: 1px solid var(--sc-border-default);
  border-radius: var(--sc-radius-md);
  cursor: pointer;
  transition: all var(--sc-duration-base) var(--sc-easing-standard);

  .v-icon {
    color: var(--v-text_secondary-base) !important;
    opacity: 0.6;
    transition: all var(--sc-duration-base) var(--sc-easing-standard);
  }
}

.appbar-pill-bug:hover {
  border-color: rgba(var(--sc-color-error-rgb), 0.3);
  background: rgba(var(--sc-color-error-rgb), 0.08);
  .v-icon {
    color: var(--sc-color-error) !important;
    opacity: 1;
  }
}

.appbar-pill-request:hover {
  border-color: rgba(var(--sc-color-edit-rgb), 0.3);
  background: rgba(var(--sc-color-edit-rgb), 0.08);
  .v-icon {
    color: var(--sc-color-edit) !important;
    opacity: 1;
  }
}

.appbar-separator {
  width: 1px;
  height: 28px;
  background: rgba(255, 255, 255, 0.12);
  margin: 0 12px;
}
</style>
